/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".global-search h2{font-size:1.25rem;text-align:center}.global-search a.csvfloat{float:right;z-index:9;font-size:1rem;position:initial}"];
export { styles as styles };
